export default __webpack_public_path__ + "static/media/success.c947f130.svg";